const mobileNavToggle = () => {
  const mobileNavBtn = document.querySelector('.navbar-toggler');
  const mobileNav = document.querySelector('.navbar-collapse');
  const body = document.querySelector('body');

  mobileNavBtn.addEventListener('click', () => {
    mobileNavBtn.classList.toggle('collapsed');
    mobileNav.classList.toggle('show-nav');
    body.classList.toggle('nav-open');
  });
}

export default mobileNavToggle;



// WEBPACK FOOTER //
// ./scripts/util/mobile-nav-toggle.js